import {BaseRouteConfig} from "../../../core/components/router/models/base-route-config";
import {ROUTE_NAMES, ROUTE_TYPES} from "../../../core/consts";
import {ReactLazyPreload} from "../../../core/components/router/react-lazy-preload";
import {CompetitionMatchModel} from "./competition.match-model";

export class CompetitionPageRouteConfig extends BaseRouteConfig {
  static injectables = [];

  constructor({name, path, componentImport, metadataType}) {
    super();

    this.name = name;
    this.path = path;
    this.parentPath = path ? `/:sportName/league/:key/${path}` : null;
    this.component = ReactLazyPreload(componentImport);
    this.metadataType = metadataType;
    this.matchType = CompetitionMatchModel;
    this.parent = ROUTE_NAMES.competition;
    this.routeType = ROUTE_TYPES.nested;
  }
}
